(function(){
    angular
        .module('appback')
        .directive('ngHecesnew', hacesnew);

        hacesnew.$inject = ['ResultadosService','$timeout'];
        function hacesnew(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=hecesnew.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {

		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { examenes: [{ color:'', consistencia:'',otros:'' }], gusanos : [], huevos:[],quistes:[] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { examenes: [{ color:'', consistencia:'',otros:'' }], gusanos : [], huevos:[],quistes:[] }};
				            }else{
				            	if(!scope.item.resultado.extra.resultado){
				            		scope.item.resultado.extra.resultado = { examenes: [{ color:'', consistencia:'',otros:'' }], gusanos : [], huevos:[],quistes:[] };
					            }else{
					            	if(Array.isArray(scope.item.resultado.extra.resultado)){
				            			scope.item.resultado.extra.resultado = { examenes: [{ color:'', consistencia:'',otros:'' }], gusanos : [], huevos:[],quistes:[] };
					            	}
				       				//console.log("resmd");
				       				//console.log(scope.item.resultado.extra.resultado);

					            }
				            }
				        }
		            	/*if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { examenes: [{ color:'', consistencia:'',otros:'' }], gusanos : [], huevos:[],quistes:[] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { examenes: [{ color:'', consistencia:'',otros:'' }], gusanos : [], huevos:[],quistes:[] }};
				            }else{
			            		if(!scope.item.resultado.extra.resultado){
			            			scope.item.resultado.extra.resultado = { examenes: [{ color:'', consistencia:'',otros:'' }], gusanos : [], huevos:[],quistes:[] };
								}
				            }
				        }*/
				        //console.log(scope.item.resultado.extra);
		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                      }
		            	scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}

	                	scope.optionsHuevos = { 
		            		ajax: {
		                        url: "/backend/altcrm/content/select2",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

	                	scope.optionsQuistes = { 
		            		ajax: {
		                        url: "/backend/altcrm/content/select2",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

	                	scope.optionsGusanos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2gusanos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}

	                	scope.nuevoGusano = function(){
	                		if(typeof(scope.item.resultado.extra.resultado.gusanos)=='undefined'){
	                			scope.item.resultado.extra.resultado.gusanos = [];
	                		}
	                		scope.item.resultado.extra.resultado.gusanos.push({});
	                	}

	                	scope.nuevoHuevo = function(){
	                		if(typeof(scope.item.resultado.extra.resultado.huevos)=='undefined'){
	                			scope.item.resultado.extra.resultado.huevos = [];
	                		}
	                		scope.item.resultado.extra.resultado.huevos.push({});
	                	}

	                	scope.addExamen = function(){
	                		if(typeof(scope.item.resultado.extra.resultado.examenes)=='undefined'){
	                			scope.item.resultado.extra.resultado.examenes = [];
	                		}
	                		scope.item.resultado.extra.resultado.examenes.push({});
	                	}

	                	scope.borrarExamen = function(index){
	                		scope.item.resultado.extra.resultado.examenes.splice(index,1);

	                	}

	                	scope.nuevoQuiste = function(){
	                		if(typeof(scope.item.resultado.extra.resultado.quistes)=='undefined'){
	                			scope.item.resultado.extra.resultado.quistes = [];
	                		}
	                		scope.item.resultado.extra.resultado.quistes.push({});
	                	}

	                	scope.borrarVerme = function(index){
	                		scope.item.resultado.extra.resultado.gusanos.splice(index,1);

	                	}

	                	scope.borrarHuevo = function(index){
	                		scope.item.resultado.extra.resultado.huevos.splice(index,1);

	                	}

	                	scope.borrarQuiste = function(index){
	                		scope.item.resultado.extra.resultado.quistes.splice(index,1);

	                	}
	                    

		                //console.log(scope.optionsColor);
		            	/*scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,function(data){
			               scope.subanaliticas = data.subanaliticas;
			            });*/
			        });
		        }
          }
      }
})();